import lang from '../../lib/language';

type WelcomeTitleParams = {
  firstName: string;
  hasOnlyDemoPlan: boolean;
  hasNoRemainingTime: boolean;
};

type DescriptionParams = {
  hasNoRemainingTime: boolean;
};

export const getWelcomeTitle = ({
  firstName,
  hasOnlyDemoPlan,
  hasNoRemainingTime,
}: WelcomeTitleParams): string => {
  if (hasOnlyDemoPlan && hasNoRemainingTime) {
    return lang.commonExpiredDemoAccountTitle();
  }

  if (hasOnlyDemoPlan) {
    return lang.welcomeReadyForRealDeal(firstName);
  }

  return lang.commonOnboardingCarousel1Title(firstName);
};

export const getDescription = ({ hasNoRemainingTime }: DescriptionParams): string =>
  (hasNoRemainingTime ? lang.nowYouFamiliarPlatform() : lang.startJourney());
